
export const mockGalleryImages = [
  {
    id: 'img-1',
    url: 'https://public.readdy.ai/ai/img_res/57b1663a8e278b1326350186a4750822.jpg',
    title: '모던 리빙룸 인테리어',
    date: '2024.12.15',
    category: '주거 공간'
  },
  {
    id: 'img-2',
    url: 'https://readdy.ai/api/search-image?query=Luxurious%20open%20concept%20kitchen%20with%20marble%20countertops%20pendant%20lights%20warm%20wood%20cabinets%20modern%20appliances%20clean%20minimalist%20design%20bright%20natural%20lighting%20architectural%20interior%20photography&width=600&height=450&seq=gal2&orientation=landscape',
    title: '오픈 컨셉 키친',
    date: '2024.11.28',
    category: '주거 공간'
  },
  {
    id: 'img-3',
    url: 'https://readdy.ai/api/search-image?query=Contemporary%20commercial%20office%20space%20with%20glass%20partitions%20ergonomic%20furniture%20green%20plants%20warm%20lighting%20collaborative%20workspace%20modern%20architecture%20clean%20professional%20environment&width=600&height=600&seq=gal3&orientation=squarish',
    title: '협업 오피스 공간',
    date: '2024.11.10',
    category: '상업 공간'
  },
  {
    id: 'img-4',
    url: 'https://readdy.ai/api/search-image?query=Elegant%20master%20bedroom%20with%20soft%20neutral%20tones%20plush%20bedding%20ambient%20lighting%20floor%20to%20ceiling%20curtains%20minimalist%20decor%20warm%20wood%20accents%20serene%20atmosphere%20architectural%20photography&width=600&height=750&seq=gal4&orientation=portrait',
    title: '마스터 베드룸',
    date: '2024.10.22',
    category: '주거 공간'
  },
  {
    id: 'img-5',
    url: 'https://readdy.ai/api/search-image?query=Modern%20retail%20store%20interior%20with%20clean%20display%20shelves%20warm%20spotlighting%20minimalist%20design%20concrete%20and%20wood%20materials%20spacious%20layout%20contemporary%20commercial%20architecture%20photography&width=600&height=400&seq=gal5&orientation=landscape',
    title: '리테일 매장 디자인',
    date: '2024.10.05',
    category: '상업 공간'
  },
  {
    id: 'img-6',
    url: 'https://readdy.ai/api/search-image?query=Renovated%20historic%20building%20interior%20blending%20old%20brick%20walls%20with%20modern%20furniture%20industrial%20chic%20style%20warm%20ambient%20lighting%20exposed%20beams%20contemporary%20renovation%20architectural%20photography&width=600&height=700&seq=gal6&orientation=portrait',
    title: '역사 건물 리모델링',
    date: '2024.09.18',
    category: '리모델링'
  },
  {
    id: 'img-7',
    url: 'https://readdy.ai/api/search-image?query=Stunning%20modern%20bathroom%20design%20with%20freestanding%20bathtub%20marble%20tiles%20warm%20wood%20vanity%20natural%20light%20minimalist%20fixtures%20spa%20like%20atmosphere%20clean%20elegant%20interior%20photography&width=600&height=600&seq=gal7&orientation=squarish',
    title: '럭셔리 바스룸',
    date: '2024.09.01',
    category: '주거 공간'
  },
  {
    id: 'img-8',
    url: 'https://readdy.ai/api/search-image?query=Cozy%20modern%20cafe%20interior%20with%20warm%20wood%20furniture%20pendant%20lights%20exposed%20brick%20wall%20green%20plants%20comfortable%20seating%20inviting%20atmosphere%20commercial%20interior%20design%20photography&width=600&height=500&seq=gal8&orientation=landscape',
    title: '카페 인테리어',
    date: '2024.08.14',
    category: '상업 공간'
  },
  {
    id: 'img-9',
    url: 'https://readdy.ai/api/search-image?query=Modern%20home%20exterior%20architecture%20with%20clean%20geometric%20lines%20large%20windows%20warm%20wood%20cladding%20landscaped%20garden%20evening%20lighting%20contemporary%20residential%20design%20photography&width=600&height=450&seq=gal9&orientation=landscape',
    title: '모던 주택 외관',
    date: '2024.07.30',
    category: '주거 공간'
  }
];
